export default {
	appEnv: 'production',
	sentryDsn: 'https://cdb0d286888981d26561579faf004478@o4508119890788352.ingest.de.sentry.io/4508119912546384',
	apiUrl: 'https://api.graph-it.fr',
	appUrl: 'http://app.graph-it.fr',
	version: 'v2.4.5'
}
